<template>
  <AppSection>
    <StripHeader>
      {{ $tt(`page.features.why_title_${countryKey || 'home'}`) }}
    </StripHeader>
    <AppContainer v-if="product" narrow class="mt-7">
      <p v-html="$tt(`page.trust.lead_${product.country}`)" class="lead text-center" />
    </AppContainer>
    <AppContainer>
      <FeatureTriad :items />
    </AppContainer>
  </AppSection>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import type { LocaleCode, Product } from '~/types';

const countryKey = inject(countryKeyInjectionKey, null);
const props = defineProps<{
  product?: Product;
}>();

const { tt } = useLocalization();
const { displayPrice } = useFormat();
const { whatsappLink, phone, supportEmail: email } = useCommunication();
const { locale, socialLinks } = useBranch();

const refundImageSrcs: Record<LocaleCode, string> = {
  sv: '/images/shields/eur.jpg',
  en: '/images/shields/usd.jpg',
  he: '/images/shields/ils.jpg',
  ru: '/images/shields/rub.jpg',
  'ru-KZ': '/images/shields/kzt.jpg'
};

const { instagram, facebook, google, vk } = socialLinks;
const price = props.product && displayPrice(props.product.price);
const items = [
  {
    src: '/images/trust-ssl-icon.jpg',
    alt: tt('page.trust.1_alt'),
    title: tt('page.trust.1_title'),
    description: tt(`page.trust.1_body_${countryKey || 'home'}`)
  },
  {
    src: refundImageSrcs[locale],
    alt: tt('page.trust.3_alt'),
    title: tt('page.trust.2_title'),
    description: tt(`page.trust.2_body_${countryKey || 'home'}`, { price })
  },
  {
    src: '/images/about/support-headphones-and-blue-crown-icon.jpg',
    alt: tt('about_page.img_support_headphones'),
    title: tt('page.trust.3_title'),
    description: tt('page.trust.3_body', { email, whatsapp: whatsappLink, phone: phone.raw, instagram, facebook, google, vk })
  }
];
</script>

<style scoped>
.lead {
  font-size: 24px;
}
</style>